export const SET_IRRIGATION_MODE_SETTING = 'SET_IRRIGATION_MODE_SETTING'
export function setIrrigationMode(mode) {
    return {
        type: SET_IRRIGATION_MODE_SETTING,
        payload: mode,
    }
}

export const SET_WATERSAVING_MODE_SETTING = 'SET_WATERSAVING_MODE_SETTING'
export function setWaterSavingMode(isActive) {
    return {
        type: SET_WATERSAVING_MODE_SETTING,
        payload: isActive,
    }
}

export const SET_BESTGROWING_MODE_SETTING = 'SET_BESTGROWING_MODE_SETTING'
export function setBestGrowingMode(isActive) {
    return {
        type: SET_BESTGROWING_MODE_SETTING,
        payload: isActive,
    }
}

export const SET_VACATION_MODE_SETTING = 'SET_VACATION_MODE_SETTING'
export function setVacationMode(isActive) {
    return {
        type: SET_VACATION_MODE_SETTING,
        payload: isActive,
    }
}

export const SET_WORKING_MODE_SETTING = 'SET_WORKING_MODE_SETTING'
export function setWorkingMode(isActive) {
    return {
        type: SET_WORKING_MODE_SETTING,
        payload: isActive,
    }
}

export const SET_NOTIFY_CONTACT_SETTING = 'SET_NOTIFY_CONTACT_SETTING'
export function setNotifyContact(isActive) {
    return {
        type: SET_NOTIFY_CONTACT_SETTING,
        payload: isActive,
    }
}

export const SET_EMAIL_NOTIFICATION_SETTING = 'SET_EMAIL_NOTIFICATION_SETTING'
export function setEmailNotifications(isActive) {
    return {
        type: SET_EMAIL_NOTIFICATION_SETTING,
        payload: isActive,
    }
}

export const SET_VACATION_NOTIFICATIONS_SETTING = 'SET_VACATION_NOTIFICATIONS_SETTING'
export function setVacationNotifications(isActive) {
    return {
        type: SET_VACATION_NOTIFICATIONS_SETTING,
        payload: isActive,
    }
}

export const SET_FROST_NOTIFICATIONS_SETTING = 'SET_FROST_NOTIFICATIONS_SETTING'
export function setFrostNotifications(isActive) {
    return {
        type: SET_FROST_NOTIFICATIONS_SETTING,
        payload: isActive,
    }
}

export const SET_MOISTURE_LOW_NOTIFICATIONS_SETTING = 'SET_MOISTURE_LOW_NOTIFICATIONS_SETTING'
export function setMoistureLowNotifications(isActive) {
    return {
        type: SET_MOISTURE_LOW_NOTIFICATIONS_SETTING,
        payload: isActive,
    }
}

export const SET_MOISTURE_HIGH_NOTIFICATIONS_SETTING = 'SET_MOISTURE_HIGH_NOTIFICATIONS_SETTING'
export function setMoistureHighNotifications(isActive) {
    return {
        type: SET_MOISTURE_HIGH_NOTIFICATIONS_SETTING,
        payload: isActive,
    }
}

export const SET_MAX_WATERING_TIME_SETTING = 'SET_MAX_WATERING_TIME_SETTING'
export function setMaxWateringTime(minutes) {
    return {
        type: SET_MAX_WATERING_TIME_SETTING,
        payload: minutes,
    }
}

export const SET_CONTACT_EMAIL_SETTING = 'SET_CONTACT_EMAIL_SETTING'
export function setContactEmail(address) {
    return {
        type: SET_CONTACT_EMAIL_SETTING,
        payload: address,
    }
}

export const SET_EMAIL_SETTING = 'SET_EMAIL_SETTING'
export function setEmail(address) {
    return {
        type: SET_EMAIL_SETTING,
        payload: address,
    }
}

export const SET_WATERING_TIME_AT_SETTING = 'SET_WATERING_TIME_AT_SETTING'
export function setWateringTimeAt(time) {
    return {
        type: SET_WATERING_TIME_AT_SETTING,
        payload: time,
    }
}

export const SET_WATERING_TIME_SETTING = 'SET_WATERING_TIME_SETTING'
export function setWateringTime(wateringTime) {
    return {
        type: SET_WATERING_TIME_SETTING,
        payload: wateringTime,
    }
}



// WEBPACK FOOTER //
// ./src/actions/settings.js